import {COLORS, mobileOnly} from '@aboutyou/ui-components';
import styled, {css} from 'styled-components';

export const HelpCenterNavigationContainer = styled.div<{light?: boolean}>`
  padding: 60px 20px;
  background: ${COLORS.Grey5};
  display: flex;
  flex-direction: column;
  align-items: center;

  ${props =>
    props.light === true &&
    css`
      background: ${COLORS.White};
      border-top: 1px solid ${COLORS.Grey3};
    `}

  ${mobileOnly(
    css`
      padding-top: 20px;
      padding-bottom: 40px;
    `,
  )}
`;
